/* Productos 24K — comportamiento del tema (sin dependencias). */
(() => {
  'use strict';

  /* ---------- Configuración ---------- */
  const decode = (value) => {
    const el = document.createElement('textarea');
    el.innerHTML = value;
    return el.value;
  };

  let config = { routes: {}, strings: {}, cartType: 'drawer' };
  try {
    const node = document.getElementById('p24-config');
    if (node) config = Object.assign(config, JSON.parse(node.textContent));
  } catch (error) {
    console.error('[P24] No se pudo leer la configuración', error);
  }
  const routes = config.routes;
  const strings = {};
  Object.keys(config.strings || {}).forEach((key) => {
    strings[key] = decode(config.strings[key]);
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = () => Boolean(window.Shopify && window.Shopify.designMode);

  /* ---------- Utilidades ---------- */
  const lockScroll = (locked) => {
    document.documentElement.style.overflow = locked ? 'hidden' : '';
  };

  const focusable = (root) =>
    Array.from(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')).filter(
      (el) => el.offsetParent !== null
    );

  const trapTab = (event, root) => {
    if (event.key !== 'Tab') return;
    const items = focusable(root);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === root)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const parseSection = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Fecha estimada de entrega ---------- */
  /** Domingo de Pascua (algoritmo gregoriano anónimo): de él salen el Viernes Santo y el Lunes de Pascua. */
  const easterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  };

  /** Festivos nacionales y de Cataluña de un año, como «mes-día». */
  const holidaysOf = (year) => {
    const days = new Set(['1-1', '1-6', '5-1', '6-24', '8-15', '9-11', '10-12', '11-1', '12-6', '12-8', '12-25', '12-26']);
    const easter = easterSunday(year);
    [-2, 1].forEach((offset) => {
      const day = new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + offset);
      days.add(day.getMonth() + 1 + '-' + day.getDate());
    });
    return days;
  };

  /** Suma días hábiles a una fecha: no cuenta sábados, domingos ni festivos. El día de partida tampoco cuenta. */
  const addBusinessDays = (from, days) => {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    const holidays = {};
    let left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      const year = date.getFullYear();
      if (!holidays[year]) holidays[year] = holidaysOf(year);
      const weekday = date.getDay();
      if (weekday === 0 || weekday === 6 || holidays[year].has(date.getMonth() + 1 + '-' + date.getDate())) continue;
      left -= 1;
    }
    return date;
  };

  const setupDeliveryEstimate = (root) => {
    root.querySelectorAll('[data-delivery-estimate]').forEach((el) => {
      const days = parseInt(el.dataset.days, 10);
      const slot = el.querySelector('[data-delivery-date]');
      if (!slot || !(days > 0)) return;
      const date = addBusinessDays(new Date(), days);
      const lang = document.documentElement.lang || 'es';
      let text;
      try {
        text = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
      } catch (error) {
        text = date.toLocaleDateString();
      }
      // «lunes, 26 de octubre» → «lunes 26 de octubre»
      if (lang.slice(0, 2) === 'es') text = text.replace(',', '');
      slot.textContent = text;
      el.hidden = false;
    });
  };

  /* ---------- Bolsa: llamadas a Shopify ---------- */
  const Cart = {
    drawer() {
      return document.querySelector('cart-drawer');
    },
    page() {
      return document.querySelector('cart-page');
    },
    sectionIds() {
      const ids = [];
      if (this.drawer()) ids.push('cart-drawer');
      const page = this.page();
      if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
      return ids;
    },
    async request(url, options) {
      let response;
      try {
        response = await fetch(url, options);
      } catch (error) {
        // sin conexión: el texto del navegador («Load failed») no le dice nada al cliente
        throw new Error(strings.cartError || 'Error');
      }
      let data = null;
      try {
        data = await response.json();
      } catch (error) {
        data = null;
      }
      if (!response.ok || !data || data.status) {
        throw new Error((data && (data.description || data.message)) || strings.cartError || 'Error');
      }
      return data;
    },
    async add(formData) {
      const ids = this.sectionIds();
      if (ids.length) {
        formData.append('sections', ids.join(','));
        formData.append('sections_url', window.location.pathname);
      }
      const data = await this.request(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      this.apply(data.sections);
      return data;
    },
    async change(line, quantity) {
      const data = await this.request(routes.cartChange + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line, quantity, sections: this.sectionIds(), sections_url: window.location.pathname }),
      });
      this.apply(data.sections);
      if (typeof data.item_count === 'number') this.setCount(data.item_count);
      return data;
    },
    apply(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        const html = sections[id];
        if (!html) return;
        const doc = parseSection(html);
        if (id === 'cart-drawer') {
          const drawer = this.drawer();
          const fresh = doc.querySelector('cart-drawer');
          if (drawer && fresh) drawer.replaceContents(fresh);
        } else {
          const page = this.page();
          const fresh = doc.querySelector('cart-page');
          if (page && fresh) {
            if (typeof page.replaceContents === 'function') page.replaceContents(fresh);
            else page.innerHTML = fresh.innerHTML;
          }
        }
      });
    },
    /** Muestra (o borra) un aviso de error dentro del panel o de la página de la bolsa. */
    notify(host, message) {
      const box = host.querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = message;
      box.hidden = !message;
    },
    /** Guarda la nota del pedido sin esperar a «Finalizar compra» (los pagos rápidos no envían el formulario). */
    saveNote(note) {
      if (!routes.cartUpdate) return Promise.resolve();
      return this.request(routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ note }),
      }).catch((error) => console.error('[P24]', error));
    },
    /** Vuelve a pedir la bolsa a Shopify (por ejemplo, al regresar con el botón «atrás»). */
    async refresh() {
      const ids = this.sectionIds();
      if (!ids.length) return;
      try {
        const response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), {
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) return;
        this.apply(await response.json());
      } catch (error) {
        /* la bolsa se actualizará en la siguiente página */
      }
    },
    setCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = String(count);
        el.hidden = count === 0;
      });
    },
  };

  /** Botones de cantidad y «Eliminar», compartidos por el panel y la página de la bolsa. */
  const handleCartClick = (event, host) => {
    const control = event.target.closest('[data-qty-change], [data-remove]');
    if (!control || !host.contains(control)) return;
    const item = control.closest('[data-line]');
    if (!item) return;
    event.preventDefault();
    // la posición de cada línea solo vale para la bolsa que está en pantalla: un cambio cada vez
    if (host.cartBusy) return;
    host.cartBusy = true;
    const line = Number(item.dataset.line);
    const current = Number((item.querySelector('[data-qty]') || {}).textContent) || 1;
    const quantity = control.hasAttribute('data-remove') ? 0 : Math.max(0, current + Number(control.dataset.qtyChange));
    const which = control.hasAttribute('data-remove') ? '[data-remove]' : '[data-qty-change="' + control.dataset.qtyChange + '"]';
    const hadFocus = host.contains(document.activeElement);
    const list = item.closest('.cart-items') || item;
    list.classList.add('is-loading');
    Cart.notify(host, '');
    Cart.change(line, quantity)
      .then(() => {
        list.classList.remove('is-loading');
        if (!hadFocus) return;
        // el contenido se ha vuelto a pintar: se devuelve el foco para que el teclado siga funcionando
        const row = host.querySelector('[data-line="' + line + '"]');
        const target =
          (row && (row.querySelector(which + ':not([disabled])') || row.querySelector('[data-qty-change="1"]'))) ||
          host.querySelector('[data-drawer-panel]') ||
          host.querySelector('.page-title');
        if (!target) return;
        if (target.matches('.page-title')) target.tabIndex = -1;
        target.focus({ preventScroll: true });
      })
      .catch((error) => {
        list.classList.remove('is-loading');
        Cart.notify(host, error.message || strings.cartError || '');
      })
      .finally(() => {
        host.cartBusy = false;
      });
  };

  /* ---------- Cabecera ---------- */
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('.mobile-menu');
      this.search = this.querySelector('.search-panel');
      this.addEventListener('click', (event) => this.onClick(event));
      this.onKey = (event) => {
        if (event.key !== 'Escape') return;
        this.toggleMenu(false, true);
        this.toggleSearch(false, true);
      };
      document.addEventListener('keydown', this.onKey);
      // por encima de 820 px el botón del menú solo existe si los enlaces no caben (cabecera compacta):
      // al ensanchar (p. ej. girar el móvil) el menú no puede quedarse abierto sin su botón
      this.wide = window.matchMedia('(min-width: 821px)');
      this.onWide = (event) => {
        this.fit();
        if (event.matches && !this.classList.contains('is-compact')) this.toggleMenu(false);
      };
      if (this.wide.addEventListener) this.wide.addEventListener('change', this.onWide);
      // con muchos enlaces el menú puede no caber aunque la pantalla sea ancha: entonces se usa el desplegable
      this.nav = this.querySelector('.header__nav');
      this.links = this.querySelector('.header__links');
      this.fit();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.fit());
        this.resizeObserver.observe(this);
      } else {
        this.onResize = () => this.fit();
        window.addEventListener('resize', this.onResize);
      }
      // las letras definitivas pueden ser más anchas que las de reserva
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fit());
      // el menú abierto tapa la página: se cierra si el foco del teclado sale de la cabecera
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.toggleMenu(false);
      });
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      if (this.wide && this.wide.removeEventListener) this.wide.removeEventListener('change', this.onWide);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      lockScroll(false);
    }
    /* Mide si los enlaces caben entre el logo y los iconos; si no caben, la cabecera pasa a compacta (botón de menú). */
    fit() {
      if (!this.nav || !this.links) return;
      const wasCompact = this.classList.contains('is-compact');
      this.classList.remove('is-compact');
      // por debajo de 820 px la hoja de estilos ya oculta los enlaces: no hay nada que medir
      const shown = window.getComputedStyle(this.nav).display !== 'none';
      const compact = shown && this.links.scrollWidth > this.nav.clientWidth - 16;
      if (compact) this.classList.add('is-compact');
      else if (wasCompact && this.wide && this.wide.matches) this.toggleMenu(false);
    }
    onClick(event) {
      if (event.target.closest('[data-menu-toggle]')) {
        this.toggleMenu(this.menu.hidden);
        return;
      }
      if (event.target.closest('[data-search-toggle]')) {
        this.toggleSearch(this.search.hidden, true);
        return;
      }
      if (event.target.closest('.mobile-menu a')) {
        this.toggleMenu(false);
        return;
      }
      const bag = event.target.closest('[data-cart-toggle]');
      if (bag) {
        const drawer = Cart.drawer();
        if (drawer && config.cartType === 'drawer') {
          event.preventDefault();
          this.toggleMenu(false);
          this.toggleSearch(false);
          drawer.open(bag);
        }
      }
    }
    toggleMenu(open, returnFocus) {
      if (!this.menu || this.menu.hidden === !open) return;
      if (open) {
        this.toggleSearch(false);
        // el menú ocupa desde el borde inferior de la cabecera hasta el final de la pantalla
        this.style.setProperty('--menu-top', Math.max(0, Math.round(this.getBoundingClientRect().bottom)) + 'px');
      }
      const hadFocus = this.menu.contains(document.activeElement);
      this.menu.hidden = !open;
      this.classList.toggle('is-menu-open', open);
      this.querySelectorAll('[data-menu-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
      lockScroll(open);
      if (!open && returnFocus && hadFocus) {
        const toggle = this.querySelector('[data-menu-toggle]');
        if (toggle) toggle.focus();
      }
    }
    toggleSearch(open, returnFocus) {
      if (!this.search || this.search.hidden === !open) return;
      if (open) this.toggleMenu(false);
      const hadFocus = this.search.contains(document.activeElement);
      this.search.hidden = !open;
      this.querySelectorAll('[data-search-toggle][aria-controls]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
      if (open) {
        const input = this.search.querySelector('input[type="search"]');
        if (input) input.focus();
      } else if (returnFocus && hadFocus) {
        const toggle = this.querySelector('[data-search-toggle][aria-controls]');
        if (toggle) toggle.focus();
      }
    }
  }

  /* ---------- Panel de la bolsa ---------- */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-drawer-close]')) {
          event.preventDefault();
          this.close();
          return;
        }
        handleCartClick(event, this);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
        else trapTab(event, this.panel);
      });
    }
    get panel() {
      return this.querySelector('[data-drawer-panel]');
    }
    open(opener) {
      this.opener = opener || document.activeElement;
      this.classList.add('is-open');
      lockScroll(true);
      window.setTimeout(() => this.panel && this.panel.focus(), 50);
    }
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      lockScroll(false);
      if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    }
    replaceContents(fresh) {
      const next = fresh.querySelector('[data-drawer-panel]');
      if (this.panel && next) {
        const body = this.querySelector('.drawer__body');
        const scrollTop = body ? body.scrollTop : 0;
        this.panel.innerHTML = next.innerHTML;
        const nextBody = this.querySelector('.drawer__body');
        if (nextBody) nextBody.scrollTop = scrollTop;
      }
      const count = Number(fresh.dataset.itemCount || 0);
      this.dataset.itemCount = String(count);
      Cart.setCount(count);
    }
  }

  /* ---------- Página de la bolsa ---------- */
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => handleCartClick(event, this));
      this.addEventListener('change', (event) => {
        if (event.target.matches('[name="note"]')) Cart.saveNote(event.target.value);
      });
    }
    replaceContents(fresh) {
      const current = Array.from(this.querySelectorAll('[data-cart-region]'));
      const next = Array.from(fresh.querySelectorAll('[data-cart-region]'));
      if (current.length && current.length === next.length) {
        // misma estructura: solo cambian las líneas y los totales (la nota y los pagos rápidos no se tocan)
        current.forEach((region, index) => {
          region.innerHTML = next[index].innerHTML;
        });
      } else {
        this.innerHTML = fresh.innerHTML;
      }
    }
  }

  /* ---------- Galería del producto ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) this.show(thumb.dataset.thumb);
      });
      let timer = null;
      this.track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => this.sync(), 80);
        },
        { passive: true }
      );
    }
    slides() {
      return Array.from(this.track.querySelectorAll('[data-media-id]'));
    }
    show(mediaId, instant) {
      const slide = this.slides().find((el) => el.dataset.mediaId === String(mediaId));
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduceMotion || instant ? 'auto' : 'smooth' });
      this.mark(String(mediaId));
    }
    sync() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      const current = this.slides().find((el) => {
        const left = el.offsetLeft - this.track.offsetLeft;
        return center >= left && center < left + el.offsetWidth;
      });
      if (current) this.mark(current.dataset.mediaId);
    }
    mark(mediaId) {
      this.thumbs.forEach((thumb) => {
        if (thumb.dataset.thumb === mediaId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
  }

  /* ---------- Ficha de producto ---------- */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.error = this.querySelector('[data-form-error]');
      this.customField = this.querySelector('[data-custom-field]');
      this.gallery = this.querySelector('media-gallery');
      this.buyBar = this.querySelector('[data-buy-bar]');

      const picker = this.querySelector('[data-variant-picker]');
      if (picker) {
        picker.addEventListener('change', (event) => this.onVariant(event.target));
        this.takeOverPicker(picker);
      }
      const plans = this.querySelector('[data-plan-picker]');
      if (plans) plans.addEventListener('change', (event) => this.onPlan(event.target));
      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.setupBuyBar();
      setupDeliveryEstimate(this);
    }
    /**
     * Sin JavaScript el formulario envía la opción marcada. Con JavaScript manda un único campo oculto
     * «id», que es también donde los botones de pago rápido de Shopify leen la variante elegida.
     */
    takeOverPicker(picker) {
      this.variantInput = this.form ? this.form.querySelector('[data-variant-id]') : null;
      const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
      if (!this.variantInput || !radios.length) return;
      const checked = radios.find((radio) => radio.checked && !radio.disabled) || radios.find((radio) => !radio.disabled);
      const initial = this.variantInput.value;
      radios.forEach((radio) => {
        radio.name = 'variant-' + (this.dataset.sectionId || 'product');
      });
      if (checked) checked.checked = true;
      this.variantInput.disabled = false;
      // el navegador puede haber restaurado otra opción (recarga, botón «atrás»): la página se pone al día
      if (checked && checked.value !== initial) this.onVariant(checked, true);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.documentElement.classList.remove('has-buy-bar');
    }
    onVariant(input, quiet) {
      if (!input || input.type !== 'radio') return;
      if (this.variantInput) this.variantInput.value = input.value;
      // con suscripciones, el precio de cada plan depende de la variante: se vuelve a pedir la página
      if (this.dataset.hasPlans === 'true' && !quiet && this.dataset.url && !inEditor()) {
        const next = new URL(window.location.href);
        next.searchParams.set('variant', input.value);
        window.location.assign(next.toString());
        return;
      }
      this.querySelectorAll('[data-price-current]').forEach((el) => {
        el.textContent = input.dataset.price;
      });
      const compare = this.querySelector('[data-price-compare]');
      if (compare) {
        compare.textContent = input.dataset.compare || '';
        compare.hidden = !input.dataset.compare;
      }
      // las variantes agotadas no se pueden marcar, así que la que se acaba de elegir se puede comprar
      this.querySelectorAll('[data-add-button]').forEach((button) => {
        button.disabled = false;
        const label = button.querySelector('[data-add-label]');
        if (label) {
          label.textContent = button.dataset.labelAdd || strings.addToCart || label.textContent;
          delete label.dataset.original;
        }
      });
      if (this.customField) {
        const isCustom = input.dataset.custom === 'true';
        this.customField.hidden = !isCustom;
        const textarea = this.customField.querySelector('textarea');
        if (textarea) textarea.disabled = !isCustom;
      }
      if (input.dataset.mediaId && this.gallery && typeof this.gallery.show === 'function') this.gallery.show(input.dataset.mediaId, quiet);
      if (!quiet && window.history.replaceState && this.dataset.url && !inEditor()) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
      this.showError('');
    }
    /** Suscripciones: al cambiar de plan (o a «compra única») se actualiza el precio que se enseña. */
    onPlan(input) {
      if (!input || input.name !== 'selling_plan') return;
      this.querySelectorAll('[data-price-current]').forEach((el) => {
        el.textContent = input.dataset.price;
      });
      const period = this.querySelector('[data-price-period]');
      if (period) {
        period.textContent = input.dataset.period || '';
        period.hidden = !input.dataset.period;
      }
      this.showError('');
    }
    setBusy(busy) {
      this.querySelectorAll('[data-add-button]').forEach((button) => {
        const label = button.querySelector('[data-add-label]');
        if (busy) {
          button.setAttribute('aria-disabled', 'true');
          if (label) {
            label.dataset.original = label.textContent;
            label.textContent = strings.adding || label.textContent;
          }
        } else {
          button.removeAttribute('aria-disabled');
          if (label && label.dataset.original) label.textContent = label.dataset.original;
        }
      });
    }
    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = !message;
      if (!message) return;
      // si se pulsó «Añadir» desde la barra inferior, el aviso queda fuera de la pantalla: se lleva a la vista
      const rect = this.error.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) this.error.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    onSubmit(event) {
      const drawer = Cart.drawer();
      if (config.cartType !== 'drawer' || !drawer || !routes.cartAdd) return;
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      this.setBusy(true);
      this.showError('');
      Cart.add(new FormData(this.form))
        .then(() => drawer.open(event.submitter))
        .catch((error) => this.showError(error.message))
        .finally(() => {
          this.busy = false;
          this.setBusy(false);
        });
    }
    setupBuyBar() {
      const anchor = this.querySelector('[data-buy-anchor]');
      if (!this.buyBar || !anchor || !('IntersectionObserver' in window) || inEditor()) return;
      this.buyBar.hidden = false;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // el área observada llega muy por debajo de la pantalla: «no visible» solo puede significar «ya se pasó»
            const past = !entry.isIntersecting;
            this.buyBar.classList.toggle('is-visible', past);
            document.documentElement.classList.toggle('has-buy-bar', past);
          });
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
      this.observer.observe(anchor);
    }
  }

  /* ---------- Estanterías con desplazamiento ---------- */
  class ScrollShelf extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-prev]')) this.move(-1);
        if (event.target.closest('[data-next]')) this.move(1);
      });
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.toggleAttribute('data-scrollable', max > 8);
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 4;
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }
    move(direction) {
      const item = this.track.firstElementChild;
      const step = item ? item.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * step * Math.max(1, Math.floor(this.track.clientWidth / step) - 1 || 1), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  const define = (name, ctor) => {
    if (!customElements.get(name)) customElements.define(name, ctor);
  };
  define('site-header', SiteHeader);
  define('cart-drawer', CartDrawer);
  define('cart-page', CartPage);
  define('media-gallery', MediaGallery);
  define('product-page', ProductPage);
  define('scroll-shelf', ScrollShelf);

  /* ---------- Selectores que envían el formulario al cambiar ---------- */
  const submitForm = (form) => {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  };
  const autoSelect = (event) => (event.target instanceof Element ? event.target.closest('select[data-auto-submit]') : null);
  // con el teclado, cada flecha cambia el valor: se espera a Intro o a salir del selector para no recargar a medias
  document.addEventListener('keydown', (event) => {
    const select = autoSelect(event);
    if (!select) return;
    if (event.key === 'Enter' && select.dataset.dirty && select.form) {
      event.preventDefault();
      submitForm(select.form);
    } else if (event.key !== 'Tab') {
      select.dataset.keyboard = 'true';
    }
  });
  document.addEventListener('pointerdown', (event) => {
    const select = autoSelect(event);
    if (select) delete select.dataset.keyboard;
  });
  document.addEventListener('change', (event) => {
    const select = autoSelect(event);
    if (!select || !select.form) return;
    if (select.dataset.keyboard) select.dataset.dirty = 'true';
    else submitForm(select.form);
  });
  document.addEventListener('focusout', (event) => {
    const select = autoSelect(event);
    if (select && select.dataset.dirty && select.form) submitForm(select.form);
  });

  /* ---------- Editor de temas: enseñar el bloque que se está editando ---------- */
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    if (!(block instanceof Element)) return;
    const details = block.closest('details');
    if (details) details.open = true;
    const track = block.closest('[data-track]');
    if (track) track.scrollTo({ left: block.offsetLeft - track.offsetLeft, behavior: 'auto' });
  });

  /* ---------- Volver con el botón «atrás»: la página guardada puede tener la bolsa antigua ---------- */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const drawer = Cart.drawer();
    if (drawer && typeof drawer.close === 'function') drawer.close();
    Cart.refresh();
  });

  /* ---------- Aparición suave al desplazar ---------- */
  const REVEAL = [
    '.hero__copy',
    '.hero__media',
    '.tile',
    '.shelf__head',
    '.shelf__scroller',
    '.craft__intro',
    '.craft__media',
    '.craft__step',
    '.gallery__head',
    '.gallery__item',
    '.custom__media',
    '.custom__copy',
    '.clients__head',
    '.clients__scroller',
    '.guarantee',
    '.faq__inner',
    '.contact-cta__inner',
  ].join(',');

  const setupReveal = (root) => {
    if (reduceMotion || inEditor() || !('IntersectionObserver' in window)) return;
    const limit = window.innerHeight * 0.92;
    const targets = Array.from(root.querySelectorAll(REVEAL)).filter((el) => el.getBoundingClientRect().top > limit);
    if (!targets.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach((el) => {
      el.classList.add('will-reveal');
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupReveal(document));
  else setupReveal(document);

  window.P24 = { Cart, addBusinessDays };
})();
